import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { take, tap } from 'rxjs/operators';
import { ProductTab } from '../../core';
import { ProductsService, ProductTabsService } from '../../services';

@Injectable({
  providedIn: 'root'
})
export class ProductTabsResolver implements Resolve<ProductTab[]> {
  constructor(private productTabsService: ProductTabsService, private productsService: ProductsService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<ProductTab[]> {
    return this.productTabsService.tabs.pipe(
      take(1),
      tap((existingTabs: ProductTab[]) => {
        const productIds = route.queryParamMap.getAll('productId');
        const newTabs = productIds
          .filter((productId) => !existingTabs.find(({ id }) => id === productId))
          .map((id) => ({
            id
          }));

        if (newTabs.length > 0) {
          this.productTabsService.addTabs(newTabs);
        }
        if (existingTabs.length > productIds.length) {
          const tabIdsToRemove = existingTabs.filter(({ id }) => !productIds.some((productId) => id === productId)).map(({ id }) => id);
          this.productTabsService.removeTabs(tabIdsToRemove);
          this.productsService.discardTabs(tabIdsToRemove);
        }
      })
    );
  }
}
